export const shortenAddr = (addr: string) =>
  addr.replace(addr.slice(7, -5), "...");
